@import '@speechki-frontend/shared/assets/scss/_vars';

.speaker-card {
    display: flex;
    gap: 14px;
    padding: 4px 0;
    border: 1px solid $divider;
    border-radius: 12px;
    padding: 12px 16px;
    transition: all 0.15s ease-in-out;
    cursor: pointer;

    &:hover {
        border-color: $orange;
    }

    &__control {
        margin-right: 8px;
    }

    &__recommend {
        margin-left: 4px;
    }

    &__name {
        font-size: 16px;
        line-height: 1.2;
        color: $text;
        font-weight: bold;
    }

    &__language {
        font-size: 14px;
        color: $gray;
        line-height: 1;
        margin-top: 5px;
    }

    &__tags {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: wrap;
        margin-top: 5px;
    }

    &__tag {
        background: $divider;
        padding: 3px 4px;
        line-height: 1;
        border-radius: 15px;
        font-size: 12px;
    }
}
